import { getCookie } from "./CommonFunctions";
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, MMB_LIVE, RAZORPAY, USER_COOKIE_NAME, USER_TYPE_COOKIE_NAME } from "./CommonVariable";

export const getClientBalance=async(walletMaster)=>{
        if(getCookie(USER_TYPE_COOKIE_NAME)==AD || getCookie(USER_TYPE_COOKIE_NAME)==EP){
            return;
        }
if(getCookie(APP_TYPE_COOKIE_NAME)===MMB_LIVE)return;
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
        const userKey = getCookie(USER_COOKIE_NAME);

        try{
            const requestBody = {
                method:"POST",
                headers:{"Content-Type":"application/json"},
                body:new URLSearchParams({
                    userKey:userKey,
                    userCode:c[1]
                })
            }
            const path = API_PATH + RAZORPAY + "getBalance";
            const resp = await fetch(path,requestBody);
            const response = await resp.json();
            console.log("balacen repsonse",response);
            const data = JSON.parse(response);
            const message = data[0].Data;
            if(message!=="Result Not Found"){
                const balance = message[0].balance;
                walletMaster.setWalletAmount(balance);
                console.log(balance);
            }else{
                console.log(message);
            }
        }catch(err){
            console.log(err);
        }

    }

export const bookingViaMoney=async(wallet,balance,awbNo)=>{
    // setPayLoading(true);
    if(getCookie(APP_TYPE_COOKIE_NAME)===MMB_LIVE)return;
    const price = Number(balance);
    const total = Number(wallet.walletAmount);
    if(price>=total){
        alert("Booking price is greater than actual wallet balance");
        return;
    };

    if(getCookie(USER_TYPE_COOKIE_NAME)===AD || getCookie(USER_TYPE_COOKIE_NAME)===EP)return;
    try{
        const appType = getCookie(APP_TYPE_COOKIE_NAME);
        const userKey = getCookie(USER_COOKIE_NAME);
        const cookie = getCookie(LOGIN_COOKIE_NAME)
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        const path = API_PATH + RAZORPAY + "booking-payment";
        const resp = await fetch(path,{
            method:"POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                userKey: userKey,
                userCode: c[1],
                amount: balance,
                awbNo:awbNo
            })
        })

        const response = await resp.json();
        console.log(response);
        if(resp.status===200){
            const data = JSON.parse(response);
            console.log(data)
            console.log(data.currentBalance);

            if(data.status==="Booked successfull"){
                wallet.setWalletAmount(data.currentBalance);
            }else{
                alert(data.status)
            }
        }else if(resp.status===409){
            const data = JSON.parse(response);
            console.log(data)
            alert(data.status)
        }else{
            alert(response);
        }
        
        
        
    }catch(err){
        console.log(err)
    }finally{
        // setPayLoading(false); 
    }
}